<template>
  <div class="doc-download">
    <div class="form-group">
      <el-select
        v-model="type"
        placeholder="Tipo de documento"
        filterable
        size="default"
        clearable
        @change="searchDocuments"
      >
        <el-option
          v-for="item in getDocumentsTypes"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        />
      </el-select>
    </div>
    <!-- TABELA -->
    <el-table
      :data="tableData"
      :height="450"
      style="width: 100%"
      empty-text="Não há dados para serem listados"
      border
      v-loading="isLoading"
    >
      <el-table-column
        prop="name"
        label="Nome"
        align="center"
      ></el-table-column>
      <el-table-column label="Ação" width="150" align="center">
        <template v-slot="file">
          <div class="actions">
            <font-awesome-icon
              :icon="iconDownload"
              @click="handleDownload(file.row)"
            />
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination
        v-if="getTotalPages > 1"
        layout="prev, pager, next"
        :total="getTotalContent"
        :current-page="getPage"
        @current-change="handlePageChange"
      />
    </div>
  </div>
</template>

<script>
/** Ícones */
// eslint-disable-next-line import/order
import { faDownload } from '@fortawesome/free-solid-svg-icons'

/** Vuex */
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'DocumenoDownload',

  components: {
    FontAwesomeIcon
  },

  data() {
    return {
      type: '',
      iconDownload: faDownload,
      tableData: [],
      currentPage: 1,
      pageSize: 10
    }
  },

  mounted() {
    this.fetchDocuments()
    this.fetchDocumentsTypes()
  },

  computed: {
    ...mapGetters('documentManagement', [
      'getDocument',
      'getDocuments',
      'getLoadingDocument',
      'getTotalPages',
      'getTotalContent',
      'getPage'
    ]),
    ...mapGetters('documentType', ['getDocumentsTypes']),

    isLoading() {
      return this.getLoadingDocument
    }
  },
  watch: {
    getPage: 'fetchDocuments',
    getDocuments: {
      handler(documents) {
        this.tableData = documents?.map((doc) => ({
          name: doc?.name,
          id: doc?.id
        }))
      },
      deep: true
    }
  },
  methods: {
    ...mapActions('documentManagement', [
      'fetchDocuments',
      'updatePage',
      'fechVoucherDownload'
    ]),
    ...mapActions('documentType', ['fetchDocumentsTypes']),
    async searchDocuments() {
      await this.fetchDocuments({
        document: null,
        type: this.type,
        page: 1,
        size: 5
      })
    },
    handleDownload(row) {
      const fileData = {
        id: row.id,
        name: row.name
      }
      this.fechVoucherDownload(fileData)
    }
  },

  handlePageChange(newPage) {
    this.currentPage = newPage
    this.fetchDocuments()
  }
}
</script>

<style scoped>
.form-group {
  display: flex;
  align-items: center;
  gap: 10px;
  button {
    width: 150px;
  }
}

h2,
h3 {
  margin-bottom: 20px;
}

label {
  display: block;
  margin-bottom: 5px;
}

select {
  width: 100%;
  padding: 8px;
  box-sizing: border-box;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  margin-bottom: 10px;
}

a {
  text-decoration: none;
  color: #007bff;
}

a:hover {
  text-decoration: underline;
}
</style>
